module.exports = __webpack_public_path__ + "img/la_base_crepe_320px.603219f7.jpg";